export default "__VITE_ASSET__eGRK8ZKb__"